import { combineReducers } from 'redux';
import { routerReducer  } from 'react-router-redux';

import homeConfig from './Props';
import homeConfig2 from './Props';
import preHeat from './Props';
import bodyCare from './Props';
import brandGroup from './Props';
import breadData from './Props';
import food from './Props';
// import brandWallSync from './Props';
import brandPageData from './Props';
import configuration from './Props';
import exclusiveSaleData from './Props';
import fragrance from './Props';
import functionData from './Props';
import SpecialOfferListData from './Props'
import hairCare from './Props';
import heroBanner from './Props';
import heroBannerGroup from './Props';
import heroBannerGroupAppointment from './Props';
import hotWordsData from './Props';
import hotSaleSetData from './Props';
import keywordData from './Props';
import keywordDataV2 from './Props';
import makeUp from './Props';
import manSkinCare from './Props';
import mainContent from './Props';
import navigationGroup from './Props';
import navigationBrandGroup from './Props';
import oneLevel from './Props';
import picks from './Props';
import picksImageAdd from './Props';
import productDetailImage from './Props';
import productDetailSKUPromotion from './Props';
import productInfo from './Props';
import rank from './Props';
import skinCare from './Props';
import searchPlaceHolder from './Props';
import searchHotWords from './Props';
import adHotBrand from './Props';
import tools from './Props';
import weeklySpecial from './Props';

import seo from "./seo";
import user from "./user";
import global from "./global";
import addressPopup from "./addressPopup";
import home from "./home"
import checkout from "./checkout"
import productDetail from "./productDetail";
import myAccountOrder from './myAccountOrder';
import myAccountOnlineReturn from './myAccountOnlineReturn';
import myAccountQA from "./myAccountQA";
import locations from "./locations";
import category from './category';
import brandWall from './brandWall';
import categoryOnelevel from './categoryOnelevel';
import myAccountAddress from './myAccountAddress';
import CouponLists from './CouponLists';
import popup_address from './popup_address';
import async from "./async";
import popup_component from "./popup_component";
import popup_alert from "./popup_alert";
import popup_DeleteList from "./popup_DeleteList";
import data from "./data";
import imagesRender from "./imagesRender";
import dataGA from "./dataGA";
import nicheFragrance from "./nicheFragrance";
import loginMemberUI from "./loginMemberUI";
import dependency from './dependency';
import purchaseRecord from './purchaseRecord';
import onLineReturn from './onLineReturn';
import messageCenter from './messageCenter';
import invoiceList from './invoiceList';
import issueInvoice from './issueInvoice';

/* 
*   SEO对象 与独立文件区分开,并以26位字母先后顺序创建
*/
const rootReducer = combineReducers({
    homeConfig,
    homeConfig2,
    preHeat,
    bodyCare,
    brandGroup,
    breadData,
    // brandWallSync,
    brandPageData,
    configuration,
    exclusiveSaleData,
    fragrance,
    functionData,
    hairCare,
    heroBanner,
    heroBannerGroup,
    heroBannerGroupAppointment,
    hotWordsData,
    hotSaleSetData,
    keywordData,
    SpecialOfferListData,
    purchaseRecord,
    keywordDataV2,
    makeUp,
    manSkinCare,
    mainContent,
    navigationGroup,
    navigationBrandGroup,
    oneLevel,
    picks,
    picksImageAdd,
    productDetailImage,
    productDetailSKUPromotion,
    productInfo,
    rank,
    skinCare,
    food,
    searchPlaceHolder,
    searchHotWords,
    adHotBrand,
    tools,
    weeklySpecial,


    async,
    addressPopup,
    brandWall,
    checkout,
    category,
    categoryOnelevel,
    CouponLists,
    data,
    dataGA,
    global,
    home,
    imagesRender,
    locations,
    loginMemberUI,
    myAccountAddress,
    myAccountOrder,
    myAccountOnlineReturn,
    myAccountQA,
    popup_component,
    popup_alert,
    popup_DeleteList,
    popup_address,
    productDetail,
    seo,
    user,
    
    nicheFragrance,
    onLineReturn,
    dependency,
    routing: routerReducer,
    messageCenter,
    invoiceList,
    issueInvoice,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./common/reducers/index.js